import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronTriangleLeftMedium"><Path d="M6.4375 12L15 19.1348V4.86523L6.4375 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleLeftMedium;
